import { render } from "./IconVegan.vue?vue&type=template&id=5f0dbf3f"
import script from "./IconVegan.vue?vue&type=script&lang=js"
export * from "./IconVegan.vue?vue&type=script&lang=js"

import exportComponent from "D:\\perso\\miam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__